<template>
	<div class="task-calendar-item-container">
		<div class="task-calendar-timeline">
			<div class="task-calendar-timeline" :style="budget_used_style"></div>
		</div>
		<div class="task-calendar-icons px-3" v-if="jobValid">
			<v-btn v-if="task.status.type === status_completed_type" small icon disabled>
				<v-icon class="ml-1" dense>mdi-check</v-icon>
			</v-btn>
			<v-btn v-if="task.status.type !== status_completed_type" small icon>
				<TimeSheet color="rgba(25, 42, 62, 0.5)" width="20" height="20" class="ml-1" @click="$emit('log-time', task.id)"/>
			</v-btn>
			<v-btn small icon @click.stop="onClickMenuItem('edit')" :disabled="task.status.type === status_completed_type">
				<Rename :color="task.status.type === status_completed_type ? 'rgba(0, 0, 0, 0.26)':'rgba(25, 42, 62, 0.5)'" width="20" height="20" class="ml-1"/>
			</v-btn>
			<TaskCalendarItemMenu
				:hasChild="task.has_child"
				:type="event_task"
				:isPrivilege="isPrivilege"
				:privileges="privileges"
				:isCompleted="task.status.type === status_completed_type"
				@click-menu-item="onClickMenuItem($event)"
				@delete="onDeleteMenuItem()"/>
		</div>
		<div class="task-calendar-item-row px-3">
			<div class="task-calendar-item-name">{{ task.title}}</div>
		</div>
		<div class="task-calendar-item-row px-3">
			<div class="task-calendar-item-column">
				<div>
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">{{ task.job.code }}</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ task.job.name }}</span>
				</div>
				<div v-if="task.phase && task.phase.name.length !== 0">
					<span class="task-calendar-item-text task-calendar-item-color-sub task-calendar-item-main">Phase:</span>&nbsp;&nbsp;
					<span class="task-calendar-item-text task-calendar-item-color-sub  task-calendar-item-sub">{{ task.phase.name }}</span>
				</div>
			</div>
		</div>
		<div class="task-calendar-item-row px-3 my-1">
			<div style="width: 60%">
				<v-select
					class="task-calendar-item-name"
					v-model="status_local"
					:items="statuses"
					:background-color="jobValid && isPrivilege ? status_local.color :'rgba(0,0,0,.12)'"
					:color="jobValid && isPrivilege ? formatColor(status_local.color) : 'rgba(0,0,0,.12)'"
					item-value="id"
					item-text="desc"
					return-object
					hide-details
					dense
					solo
					flat
					:disabled="!jobValid || !isPrivilege"
					@click.stop
					@change="onStatusChange($event)"
				>
					<template v-slot:append>
						<v-icon :style="`color: ${ jobValid && isPrivilege ? formatColor(status_local.color) : 'rgba(0,0,0,.26)'}`">mdi-chevron-down</v-icon>
					</template>
					<template v-slot:selection="{ item }">
						<span :style="`color: ${ jobValid && isPrivilege ? formatColor(status_local.color) : 'rgba(0,0,0,.26)'}`">{{ item.desc }}</span>
					</template>
					<template v-slot:item="{item, on}">
						<v-list-item v-on="on" dense>
							<v-badge
								:color="item.color"
								left
								inline
							>
								<span class="ml-1 task-calendar-item-name">{{ item.desc }}</span>
							</v-badge>					
						</v-list-item>
					</template>
				</v-select>
			</div>
			<div v-if="task.child_count !== 0" class="task-calendar-icons" style="align-items: flex-start">
				<SubTask color="rgba(25, 42, 62, 0.5)" width="20" height="20" class="mr-1"/>
				<span>{{ task.child_count }}</span>
			</div>
		</div>
		<div class="task-calendar-item-row px-3 task-calendar-bottom">
			<div>
				<template v-if="task.task_days <= 1">
					<span v-if="start_date && task.start_time.length === 0" class="task-calendar-item-text task-calendar-item-color-main task-calendar-item-main">{{ start_date }}</span>
					<span v-if="start_date && task.start_time.length !== 0" class="task-calendar-item-text task-calendar-item-color-main task-calendar-item-sub">&nbsp;{{ task.start_time }}&nbsp;-&nbsp;{{ task.end_time }}</span>
					<span v-if="!start_date" class="task-calendar-item-text task-calendar-item-color-main task-calendar-item-main">{{ task.task_days }}&nbsp;day</span>
				</template>
				<template v-if="task.task_days > 1">
					<span v-if="start_date && end_date" class="task-calendar-item-text task-calendar-item-color-main task-calendar-item-main">{{ start_date }}&nbsp;-&nbsp;{{ end_date }}</span>
					<span v-if="!start_date && !end_date" class="task-calendar-item-text task-calendar-item-color-main task-calendar-item-main">{{ task.task_days }}&nbsp;days</span>
				</template>
			</div>
			<div>
				<span class="task-calendar-item-text task-calendar-item-main task-calendar-item-color-main">{{ actual }} </span>
				<span class="task-calendar-item-text task-calendar-item-sub task-calendar-item-color-main">of <span :class="task.budget === 0 ? 'task-calendar-item-color-red':''">{{ budget }}</span></span>
			</div>
		</div>
		<div class="px-3 task-calendar-item-text task-calendar-item-color-main task-calendar-item-sub task-calendar-bottom">{{ getWorkdayString(task.workdays) }}</div>
		<div v-if="task_for.length > 0" class="task-calendar-item-row px-3 py-2 task-calendar-bottom" style="justify-content: flex-start">
			<div v-for="task_for_item in task_for" :key="task_for_item.id" class="avatar-hover">
				<v-tooltip top color="#FFFFFF">
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<v-user-avatar
								style="font-size: 0.75rem"
								size="24"
								class="mr-1"
								:code="task_for_item.name"
								:image="`/api/addressbook/${task_for_item.id }/image.png`"
							/>
						</div>
					</template>
					<span class="task-calendar-item-text task-calendar-item-main task-calendar-item-color-main ">{{ task_for_item.name }}</span>
				</v-tooltip>
			</div>
		</div>
	</div> 
</template>
<script>
import TimeSheet from "@/components/icons/timesheet";
import TaskCalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";
import Rename from '@/components/icons/rename';
import SubTask from '@/components/icons/sub_task';

import { colorContrastChecker } from '@/common/colorChecker.js';
import { durationMixin } from "@/mixins/misc/durationMixin";
import moment from 'moment';
import config from "@/config.js";

const GreenColor = '#00DD00';
const FullColor = 'rgb(192, 165, 39)';
const Event_Task = 'task';

const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;

const Workdays = [
	{ 
		key: 'Monday',
		text: 'M',
		isWork: true
	},
	{ 
		key: 'Tuesday',
		text: 'T',
		isWork: true
	},
	{ 
		key: 'Wednesday',
		text: 'W',
		isWork: true
	},
	{ 
		key: 'Thursday',
		text: 'T',
		isWork: true
	},
	{ 
		key: 'Friday',
		text: 'F',
		isWork: true
	},
	{ 
		key: 'Saturday',
		text: 'S',
		isWork: false
	},
	{ 
		key: 'Sunday',
		text: 'S',
		isWork: false
	}
];

export default {
	mixins: [ durationMixin ],
	name: 'TaskCalendarItem',
	props: {
		task: {
			type: Object,
			default: () => {}
		},
		isPrivilege: {
			type: Boolean,
			default: true
		},
		privileges: {
			type: Array,
			default: () => []
		},
		jobValid: {
			type: Boolean,
			default: true
		},
		statuses: {
			type: Array,
			default: () => []
		},
		taskWorkday: {
			/** from Monday to Sunday */
			type: Array,
			default: () => []
		}
	},
	components: {
		TimeSheet,
		TaskCalendarItemMenu,
		Rename,
		SubTask
	},
	data() {
		this.status_completed_type = config.status_completed_type;
		this.event_task = Event_Task;
		return {
			status_local: this.task.status,
		}
	},
	computed: {
		start_date() {
			let date = null;
			if (this.task.start_date) {
				const isGentalFormat = moment(this.task.start_date).isValid();
				date = isGentalFormat ? moment(this.task.start_date).format('DD MMM') : moment(this.task.start_date, 'Do MMM YYYY').format('DD MMM')
			}
			return date;
		},
		end_date() {
			let date = null;
			if (this.task.end_date) {
				const isGentalFormat = moment(this.task.end_date).isValid();
				date = isGentalFormat ? moment(this.task.end_date).format('DD MMM') : moment(this.task.end_date, 'Do MMM YYYY').format('DD MMM')
			}
			return date;
		},
		budget() {
			return this.task && this.task.budget !== 0 ? this.format_duration(this.task.budget) : 'no budget';
		},
		actual() {
			return this.task && this.task.actual !== 0 ? this.format_duration(this.task.actual) : '0h';
		},
		budget_used_style() {
			let style="width: ";

			if (this.task) {
				if (this.task.budget === 0) {
					style += "100%; background-color: #EDEFF1;";	
				} else {
					if (this.task.actual === 0) {
						style += "100%; background-color: #FFFFFF;";	
					} else if (this.task.budget_used < 70) {
						style += this.task.budget_used + `%; background-color: ${GreenColor};` + 'border-radius: 4px 0 0 0 ';
					} else if (this.task.budget_used <= 100) {
						style += this.task.budget_used +`%; background-color: ${FullColor};` + 'border-radius: 4px 0 0 0 ';
					} else {
						style += "100%; background-color: rgb(204, 26, 12);";				
					}
				}
			} else {
				style += '0%';
			}
		
			return style;
		},
		task_for() {
			let assigned_tmp = [];

			if (this.task && this.task.task_for && this.task.task_for.length !== 0) {
				const task_for_tmp = this.task.task_for;
				task_for_tmp.forEach(t => {
					let id = 0;
					if (t.Type === DEPARTMENTS) {
						id = t.DepartmentId;
					}
					if (t.Type === ROLES) {
						id = t.RoleId;
					}
					if (t.Type === ALLEMPLOYEES) {
						id = t.AbookId;
					}

					const name = this.formatName(t.DisplayName);

					const obj = {
						id: id,
						name: name
					};

					assigned_tmp.push(obj);
				});
			}

			return assigned_tmp;
		}
	},
	methods: {
		onClickMenuItem(key) {
			if (key === 'edit') {
				if (this.task.status.type !== this.status_completed_type) {
					this.$emit('edit', this.task);
				}
			}
			if (key === 'duplicate') {
				this.$emit('duplicate', this.task);
			}
			if (key === 'additem') {
				this.$emit('additem', this.task);
			}
			if (key === 'find') {
				this.$emit('find', this.task.id);
			}
			if (key === 'share') {
				this.$emit('share', this.task.id);
			}
			if (key === 'subtask') {
				this.$emit('subtask', this.task);
			}
		},
		onDeleteMenuItem() {
			this.$emit('delete', this.task);
		},
		onStatusChange(status_obj) {
			const obj = {
				task_id: this.task.id,
				status_id: status_obj.id
			};

			this.$emit('status', obj)
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		formatColor(background_color) {
			const color_res = colorContrastChecker(background_color);
			return `${color_res}`
		},
		getWorkdayString(workdays) {
			const workday_arr = [];

			const workdays_by_setting = [];
			this.taskWorkday.forEach(day => {
				if (day[0].length !== 0 && day[1].length !== 0) {
					workdays_by_setting.push(1);
				} else {
					workdays_by_setting.push(0);
				}
			});

			if (workdays !== workdays_by_setting.join('')) {
				Workdays.forEach(( w, index )=> {
					if (Number(workdays[index]) === 1) {
						workday_arr.push(w.key);
					}
				});
			}

			let workday_str = '';

			if (workday_arr.length === 1) {
				workday_str = `Applies ${workday_arr[0]}s`;
			}

			if (workday_arr.length > 1) {
				workday_str = `Applies ${workday_arr.slice(0, workday_arr.length).join('s, ')}s`;
			}

			return workday_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.task-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(25, 42, 62, 0.3);
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
}
.task-calendar-timeline {
	height: 8px;
	background-color: #DADADA;
	border-radius: 4px 4px 0 0 ;
}
.task-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-calendar-icons {
	display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}
.task-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
.task-calendar-item-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #192A3E;
}
.task-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.task-calendar-item-main {
  font-weight: 500;
}
.task-calendar-item-sub {
  font-weight: 400;
}
.task-calendar-item-color-main {
  color: #192A3E;
}
.task-calendar-item-color-sub {
  color: rgba(25, 42, 62, 0.5);
}
.task-calendar-item-color-red {
	color: #192A3E;
	font-weight: 500;
}
.task-calendar-bottom {
	background-color:#FAFAFA;
}
.avatar-hover {
	&:hover {
		cursor: pointer;
	}
}
.v-tooltip__content{
	border: 1px solid #192A3E !important;
	opacity: 1 !important;
}
::v-deep {
	.v-badge__badge {
		min-width: 14px;
		height: 14px;
	}
}
</style>
